// Complete US State FIPS codes mapping - includes all 50 states + DC
export const STATE_FIPS = {
  "01": "AL", "02": "AK", "04": "AZ", "05": "AR", "06": "CA", "08": "CO", 
  "09": "CT", "10": "DE", "11": "DC", "12": "FL", "13": "GA", "15": "HI", 
  "16": "ID", "17": "IL", "18": "IN", "19": "IA", "20": "KS", "21": "KY", 
  "22": "LA", "23": "ME", "24": "MD", "25": "MA", "26": "MI", "27": "MN", 
  "28": "MS", "29": "MO", "30": "MT", "31": "NE", "32": "NV", "33": "NH", 
  "34": "NJ", "35": "NM", "36": "NY", "37": "NC", "38": "ND", "39": "OH", 
  "40": "OK", "41": "OR", "42": "PA", "44": "RI", "45": "SC", "46": "SD", 
  "47": "TN", "48": "TX", "49": "UT", "50": "VT", "51": "VA", "53": "WA", 
  "54": "WV", "55": "WI", "56": "WY"
};

export const GEO_URL = '/states-10m.json';

// Color scales for maps
export const getRiskColor = (level) => {
  switch(level) {
    case 'high': return '#ef4444';
    case 'moderate': return '#f59e0b';
    case 'low': return '#10b981';
    default: return '#e2e8f0';
  }
};

export const getRateColor = (rate, usAverage) => {
  if (!rate) return '#e2e8f0';
  const diff = rate - usAverage;
  if (diff > 3) return '#fca5a5'; // Much higher - red
  if (diff > 1) return '#fde68a'; // Higher - amber
  if (diff < -3) return '#86efac'; // Much lower - green
  if (diff < -1) return '#bbf7d0'; // Lower - light green
  return '#d1d5db'; // Near average - gray
};

// News thumbnail sources for variety
export const NEWS_THUMBNAILS = {
  chronic: [
    'https://images.pexels.com/photos/7723401/pexels-photo-7723401.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/5721676/pexels-photo-5721676.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/7722791/pexels-photo-7722791.jpeg?auto=compress&w=400',
  ],
  vaccine: [
    'https://images.pexels.com/photos/5207034/pexels-photo-5207034.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/5863365/pexels-photo-5863365.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/3952224/pexels-photo-3952224.jpeg?auto=compress&w=400',
  ],
  policy: [
    'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&w=400',
  ],
  research: [
    'https://images.pexels.com/photos/3912364/pexels-photo-3912364.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/3825527/pexels-photo-3825527.jpeg?auto=compress&w=400',
  ],
  general: [
    'https://images.pexels.com/photos/3259629/pexels-photo-3259629.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/4386467/pexels-photo-4386467.jpeg?auto=compress&w=400',
  ],
  autoimmune: [
    'https://images.pexels.com/photos/7722791/pexels-photo-7722791.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/5721676/pexels-photo-5721676.jpeg?auto=compress&w=400',
  ],
  urgent: [
    'https://images.pexels.com/photos/3952224/pexels-photo-3952224.jpeg?auto=compress&w=400',
    'https://images.pexels.com/photos/4167541/pexels-photo-4167541.jpeg?auto=compress&w=400',
  ],
};
